var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 64,
    viewBox: "0 0 166 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "app_store",
    "data-name": "app store",
    transform: "translate(-375 -1513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    d: "M20,0H146a20,20,0,0,1,20,20V54a10,10,0,0,1-10,10H10A10,10,0,0,1,0,54V20A20,20,0,0,1,20,0Z",
    transform: "translate(375 1513)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Download_on_the",
    "data-name": "Download on the",
    transform: "translate(416 1537)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Mulish-Regular, Mulish"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download on the")), /*#__PURE__*/React.createElement("text", {
    id: "App_Store-2",
    "data-name": "App Store",
    transform: "translate(416 1562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "Mulish-Medium, Mulish",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "App Store")), /*#__PURE__*/React.createElement("g", {
    id: "apple-logo",
    transform: "translate(380.896 1529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(2.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M17.52,0h.226a6.8,6.8,0,0,1-1.713,5.127,5.311,5.311,0,0,1-4.675,2.195A6.6,6.6,0,0,1,13.1,2.354,7.533,7.533,0,0,1,17.52,0Z",
    transform: "translate(0.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M27.1,20.65v.061a17.912,17.912,0,0,1-2.553,4.936c-.974,1.344-2.167,3.152-4.3,3.152-1.841,0-3.063-1.187-4.95-1.219-2-.032-3.093.993-4.918,1.251H9.765a5.556,5.556,0,0,1-3.209-2.217A19.458,19.458,0,0,1,2.1,15.436V14.06a9.019,9.019,0,0,1,3.924-7.4,6.611,6.611,0,0,1,4.449-1.033,11.167,11.167,0,0,1,2.18.627,6.007,6.007,0,0,0,2.179.655,5.219,5.219,0,0,0,1.528-.469,9.38,9.38,0,0,1,4.918-.875,6.82,6.82,0,0,1,5.013,3,6.457,6.457,0,0,0-3.268,6.4A6.607,6.607,0,0,0,27.1,20.65Z",
    transform: "translate(-2.104 2.17)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app_store.c4db5ad49d79778544e5bb4fbf8c323b.svg";
export { ForwardRef as ReactComponent };